<script lang="ts">
export default {
  name: 'AppButton',
}
</script>

<script setup lang="ts">

const props = withDefaults(defineProps<{
  primary?: boolean,
  secondary?: boolean,
  outline?: boolean,
  loading?: boolean,
  disabled?: boolean,
}>(), {
  primary: false,
  secondary: false,
  outline: false,
  loading: false,
  disabled: false,
});

</script>

<template>
  <button class="tw:btn tw:btn-sm tw:rounded-sm"
          :class="{
            'tw:btn-primary': props.primary,
            'tw:btn-secondary': props.secondary,
            'tw:btn-outline': props.outline,
            'tw:btn-disabled': props.disabled,
          }"
          :disabled="disabled"
  >
    <span v-if="loading" class="tw:loading tw:loading-spinner"></span>
    <slot/>
  </button>
</template>
